import { useMutation, useQuery } from "@tanstack/react-query";
import { middlewareErrorMessage } from "@/api/middleware";
import { qk } from "@/api/queryKeys";
import { endSupportSession, getSupportSession, startSupportSession } from "@/api/support";
import { toast } from "@/lib/toast";

/** The platform admin's live support session. Only asked for once they are signed in on the platform address. */
export function useSupportSession(enabled: boolean) {
  return useQuery({
    queryKey: qk.platform.support(),
    queryFn: getSupportSession,
    enabled,
    staleTime: 0,
    retry: false,
  });
}

/** Opens the session, then loads the organization's app from the start (a clean page, no console data mixed in). */
export function useStartSupport() {
  return useMutation({
    mutationFn: ({ tenantId, reason }: { tenantId: string; reason: string }) => startSupportSession(tenantId, reason),
    meta: { suppressErrorToast: true },
    onSuccess: () => window.location.assign("/home"),
    onError: (error) => toast.error("Couldn't start the support session", { description: middlewareErrorMessage(error) }),
  });
}

export function useEndSupport() {
  return useMutation({
    mutationFn: endSupportSession,
    meta: { suppressErrorToast: true },
    onSuccess: () => window.location.assign("/"),
    onError: (error) => toast.error("Couldn't end the support session", { description: middlewareErrorMessage(error) }),
  });
}
